import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext'; // Importiere den AuthContext
import { translate } from './translateFunction'; // Importiere die Übersetzungsfunktion

const NewPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false); // Erfolgsmeldung
  const [userId, setUserId] = useState(null); // Speichern der userId
  const [translations, setTranslations] = useState({
    setPasswordTitle: '',
    newPassword: '',
    confirmNewPassword: '',
    changePassword: '',
    passwordsMismatch: '',
    passwordChanged: '',
    redirecting: '',
    changePasswordError: ''
  }); // Übersetzungen

  const navigate = useNavigate();
  const { logout } = useContext(AuthContext); // Zugriff auf die logout-Funktion

  // Lade Übersetzungen beim Mount
  useEffect(() => {
    const loadTranslations = async () => {
      const setPasswordTitle = await translate(426); // "Neues Passwort setzen"
      const newPassword = await translate(427); // "Neues Passwort"
      const confirmNewPassword = await translate(428); // "Passwort wiederholen"
      const changePassword = await translate(429); // "Passwort ändern"
      const passwordsMismatch = await translate(430); // "Die Passwörter stimmen nicht überein."
      const passwordChanged = await translate(431); // "Passwort erfolgreich geändert."
      const redirecting = await translate(432); // "Du wirst in Kürze weitergeleitet."
      const changePasswordError = await translate(433); // "Fehler beim Ändern des Passworts. Bitte versuche es erneut."

      setTranslations({
        setPasswordTitle,
        newPassword,
        confirmNewPassword,
        changePassword,
        passwordsMismatch,
        passwordChanged,
        redirecting,
        changePasswordError
      });
    };

    loadTranslations();
  }, []);

  // Funktion, um die UserID aus dem Token zu extrahieren
  const getUserIdFromToken = () => {
    const token = localStorage.getItem('token');
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.userId;
  };

  // Holen der userId aus dem Token beim Mount
  useEffect(() => {
    const id = getUserIdFromToken();
    if (id) {
      setUserId(id);
    } else {
      setError(translations.authError || 'Benutzer nicht authentifiziert.');
    }
  }, [translations]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      setError(translations.passwordsMismatch);
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/change-password', { userId, password }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Nach dem erfolgreichen Passwort-Update
      setSuccess(true);

      // 3 Sekunden warten, dann logout ausführen und weiterleiten
      setTimeout(async () => {
        await logout(); // Abmeldung durchführen
        navigate('/login'); // Weiterleitung nach /login
      }, 3000);
    } catch (error) {
      setError(translations.changePasswordError);
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-4">
          <div className="card">
            <div className="card-body">
              <h1 className="card-title">{translations.setPasswordTitle}</h1>
              {error && <div className="alert alert-danger">{error}</div>}
              {success ? (
                <div className="feedback-success-message" style={{ textAlign: 'center' }}>
                  <div className="checkmark">&#10003;</div>
                  <h3>
                    {translations.passwordChanged}
                    <br />
                    {translations.redirecting}
                  </h3>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="password">{translations.newPassword}</label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder={translations.newPassword}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="confirmPassword">{translations.confirmNewPassword}</label>
                    <input
                      type="password"
                      className="form-control"
                      id="confirmPassword"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder={translations.confirmNewPassword}
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary btn-block" disabled={!userId}>
                    {translations.changePassword}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPassword;
